module.exports = __webpack_public_path__ + "static/media/logo-5a.f25b6d3b.png";